/* eslint-disable import/prefer-default-export */
import { useTranslation } from "react-i18next";

export const useAlternativeWording = (
  displayAlternativeWording = false,
  nonOppositionConsent = false,
) => {
  const { t } = useTranslation();
  const isAlternativeWording =
    displayAlternativeWording && nonOppositionConsent;

  const getModalTitle = key => {
    if (isAlternativeWording) {
      return t(`consents:${key}.title.noOppoVariant`);
    }

    return nonOppositionConsent
      ? t(`consents:${key}.title.noOppo`)
      : t(`consents:${key}.title.consent`);
  };

  const getText = key => {
    if (isAlternativeWording) {
      return t(`consents:${key}.content.noOppoVariant`);
    }
    return nonOppositionConsent
      ? t(`consents:${key}.content.noOppo`)
      : t(`consents:${key}.content.consent`);
  };

  const getAcceptanceButtonText = (isAlreadyValidated = false) => {
    if (isAlternativeWording) {
      return isAlreadyValidated
        ? t(`consents:acceptModal.action.revokeOppo`)
        : t(`consents:acceptModal.action.noOppo`);
    }

    return nonOppositionConsent ? "Autoriser" : t("common:accept");
  };

  const getRefusalButtonText = (modalActionButton = true) => {
    if (isAlternativeWording) {
      return modalActionButton
        ? t(`consents:revokeModal.action.noOppo`)
        : t("common:oppose");
    }
    return nonOppositionConsent ? t("common:refuse") : t("common:revoke");
  };

  return {
    getText,
    getModalTitle,
    getAcceptanceButtonText,
    getRefusalButtonText,
  };
};
